import { ReactElement, ReactNode } from 'react';
import { useGetUserinfo } from '../../hooks/queries/useGetUserinfo';
import { UserRoles } from '../../api/queries';
import { PageProblem } from './PageProblem';

/**
 * A part of the app for some roles only, such as HR or the administration of the organization. Others are told they
 * have no access, and never see the part's menus or forms. The API decides what they may do; this only spares them
 * a page that cannot work.
 */
export const RequireRole = ({
  anyOf,
  children,
}: {
  anyOf: ReadonlyArray<UserRoles>;
  children: ReactNode;
}): ReactElement | null => {
  const { data, isLoading } = useGetUserinfo();
  // Nothing is shown until the roles are known, so the page does not flash
  if (isLoading) return null;
  const roles = data?.userRoles ?? [];
  return anyOf.some((role) => roles.includes(role)) ? <>{children}</> : <PageProblem kind="noAccess" />;
};
